import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/lib/auth";
import { Lock, ArrowLeft } from "lucide-react";

export default function AdminLoginPage() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/admin");
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[calc(100vh-72px)] flex items-center justify-center px-6 py-20">
      <Helmet>
        <title>Admin Login | Karim Benna IT Consulting</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-mono text-[var(--text-2)] hover:text-[var(--gold)] transition-colors mb-10"
        >
          <ArrowLeft size={14} /> Zurück zur Seite
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <Lock size={16} className="text-[var(--gold)]" />
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[var(--text-2)]">
            Admin · Anmelden
          </span>
        </div>
        <h1 className="font-display text-4xl lg:text-5xl tracking-tight mb-10">
          Willkommen zurück.
        </h1>

        <form onSubmit={onSubmit} data-testid="login-form" className="space-y-6">
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--text-2)]">
              E-Mail
            </span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-2 w-full bg-transparent border-b hairline focus:border-[var(--gold)] outline-none py-2 text-[var(--text-0)]"
            />
          </label>
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[var(--text-2)]">
              Passwort
            </span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-2 w-full bg-transparent border-b hairline focus:border-[var(--gold)] outline-none py-2 text-[var(--text-0)]"
            />
          </label>

          {error && (
            <div
              data-testid="login-error"
              role="alert"
              aria-live="polite"
              className="text-sm text-red-400 border border-red-500/40 bg-red-500/5 p-3"
            >
              {String(error)}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {busy ? "Anmelden..." : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
